import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '../firebase'
import store from '../store'
import Dashboard from '../views/Dashboard.vue'
import Unauthorized from '../views/Unauthorized.vue'
import Reels from '@/views/reels/Reels.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/reels',
    name: 'Reels',
    component: Reels,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/project/:projectId/assistants/c/:chatId',
    name: 'Project assistant chat',
    component: () =>import( /* webpackChunkName: "AssistantChat" */ '../views/assistantchat/AssistantChat.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reels/:id',
    name: 'Reel',
    component: () =>import( /* webpackChunkName: "reel" */ '../views/reels/Reel.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/reels/:id/dl',
    name: 'ReelDownload',
    component: () =>import( /* webpackChunkName: "reel" */ '../views/reels/Reel.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/share/reel/:id',
    name: 'SharedReel',
    component: () =>import( /* webpackChunkName: "sharedReel" */ '../views/reels/SharedReel.vue')
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path:'/project/:projectId',
  //   name: 'Project',
  //   component: () =>import( /* webpackChunkName: "login" */ '../views/projects/ProjectLayout.vue'),
  //   meta:{
  //     requiresAuth: true,
  //     can
  //   },
  // },
  {
    path:'/projects',
    name: 'Projects',
    component: () =>import( /* webpackChunkName: "login" */ '../views/projects/Projects.vue'),
    meta:{
      requiresAuth: true
    },

  },
  {
    path: '/login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import( /* webpackChunkName: "login" */ '../views/auth/VerifyEmail.vue'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/completeSignup',
    name: 'CompleteSignup',
    component: () => import( /* webpackChunkName: "completeSignup" */ '../views/CompleteSignup.vue'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/add-company',
    name: 'AddCompany',
    component: () => import( /* webpackChunkName: "AddCompany" */ '../views/AddCompany.vue'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import( /* webpackChunkName: "settings" */ '../views/settings/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/editor',
    name: 'editor',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/session/Transcript.vue'),
    meta: {
      requiresAuth: true,
      isCollaborative: true,
    }
  },
  {
    path: '/search',
    name: 'search',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/search/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/repository/:workspace_id',
    name: 'repository',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/search/index.vue'),
    meta: {
      requiresAuth: true,
      isRepositoryView: true
    }
  },
  {
    path: '/workspace/:id',
    name: 'workspace',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/workspace/Workspace.vue'),
  },
  {
    path: '/workspace',
    name: 'workspaces',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/workspace/Workspace.vue'),
  },
  {
    path: '/brewnote/editor/:id',
    name: 'brewnote editor',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/brew-note/Transcript.vue'),
  },
  {
    // /search/screens -> /search?q=screens
    path: '/brewnote/editor',
    redirect: '/brewnote/editor/sample'
  },
  {
    path: '/brewnote',
    name: 'brewnote',
    props: true,
    component: () => import(/* webpackChunkName: "editor" */'../views/brew-note/DisabledHome.vue'),
  },
  {
    path:'/calendar',
    name:'calendar',
    props: true,
    component: () => import(/* webpackChunkName: "calendar"*/'../views/calendar/index.vue'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/participants',
    name: 'Participants',
    component: () => import(/* webpackChunkName: "participants" */ '../views/participants/Participants.vue'),
    meta: {
      requiresAuth: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/participants/:participantId',
    name: 'ParticipantDetail',
    component: () => import(/* webpackChunkName: "participants" */ '../views/participants/ParticipantDetail.vue'),
    meta: {
      requiresAuth: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/opt-in-form',
    name: 'OptInForm',
    redirect: { path: '/settings', query: { tab: 'opt-in-form' } },
    meta: {
      requiresPanelManagement: true,
    },
  },
  {
    path: '/opt-in-form/screener/create',
    name: 'ScreenerCreate',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerBuilder.vue'),
    meta: {
      requiresAuth: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/opt-in-form/screener/edit',
    name: 'ScreenerEdit',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerBuilder.vue'),
    meta: {
      requiresAuth: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/opt-in-form/screener/preview',
    name: 'ScreenerPreview',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerTake.vue'),
    meta: {
      requiresAuth: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/opt-in-form/:workspaceId',
    name: 'WorkspaceOptInForm',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/WorkspaceOptInForm.vue'),
    meta: {
      requiresAuth: false,
      zeroTopNavMargin: true,
      publicScreener: true,
    },
  },
  {
    path: '/opt-in-form/:screenerId',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerDetail.vue'),
    meta: {
      requiresAuth: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
    children: [
      {
        path: '',
        redirect: 'questions',
      },
      {
        path: 'questions',
        name: 'ScreenerQuestions',
        component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerQuestionsView.vue'),
        meta: {
          requiresAuth: true,
          zeroTopNavMargin: true,
        },
      },
      {
        path: 'responses',
        name: 'ScreenerResponses',
        component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerResponsesList.vue'),
        meta: {
          requiresAuth: true,
          zeroTopNavMargin: true,
        },
      },
    ],
  },
  {
    path: '/share/session/:id',
    name: 'session_share',
    // props: true,
    component: () => import(/* webpackChunkName: "settings" */'../views/session/Transcript.vue'),
  },
  {
    path: '/summary/:projectId',
    name: 'summary',
    // props: true,
    component: () => import(/* webpackChunkName: "settings" */'../views/summary/index.vue'),
  },
  {
    path: '/tagboard',
    name: 'tagboard',
    // props: true,
    component: () => import(/* webpackChunkName: "tagboard" */'../views/Tagboard.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/highlights',
    name: 'highlights',
    // props: true,
    component: () => import(/* webpackChunkName: "settings" */'../views/Highlights.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/snippet/:id',
    name: 'snippet',
    // props: true,
    component: () => import(/* webpackChunkName: "settings" */'../views/Snippet.vue'),
  },
  {
    path: '/share/snippet/:id',
    name: 'snippet',
    // props: true,
    component: () => import(/* webpackChunkName: "settings" */'../views/Snippet.vue'),
  },
  {
    path: '/zoom_callback',
    name: 'Zoom Callback',
    component: () => import( /* webpackChunkName: "login" */ '../views/ZoomCallback.vue')
  },
  {
    path: '/notes/:id',
    name: 'Notetaking',
    component: () => import( /* webpackChunkName: "notetaking" */ '../views/Notetaking.vue')
  },
  {
    path: '/project/:projectId/sessions',
    name: 'Project Sessions',
    component: () => import( /* webpackChunkName: "notetaking" */ '../views/projects/ProjectSessions.vue'),
    meta:{
      isCollaborative: true,
    }
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/project/:projectId/screener',
    name: 'Project Screener',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ProjectScreener.vue'),
    meta: {
      isCollaborative: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/project/:projectId/screener/create',
    name: 'Project Screener Create',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerBuilder.vue'),
    meta: {
      isCollaborative: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/project/:projectId/screener/edit',
    name: 'Project Screener Edit',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerBuilder.vue'),
    meta: {
      isCollaborative: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/project/screener/:token',
    name: 'Project Screener Token Take',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerTake.vue'),
    meta: {
      requiresAuth: false,
      zeroTopNavMargin: true,
      publicScreener: true,
      projectScreenerTokenTake: true,
    },
  },
  {
    path: '/project/:projectId/screener/preview',
    name: 'Project Screener Preview',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerTake.vue'),
    meta: {
      isCollaborative: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/project/:projectId/screener/:screenerId',
    name: 'Project Screener Take',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerTake.vue'),
    meta: {
      requiresAuth: false,
      zeroTopNavMargin: true,
      publicScreener: true,
    },
  },
  {
    path: '/project/:projectId/screener/:screenerId',
    component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerDetail.vue'),
    meta: {
      isCollaborative: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
    children: [
      {
        path: '',
        redirect: 'questions',
      },
      {
        path: 'questions',
        name: 'Project Screener Questions',
        component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerQuestionsView.vue'),
        meta: {
          isCollaborative: true,
          zeroTopNavMargin: true,
        },
      },
      {
        path: 'responses',
        name: 'Project Screener Responses',
        component: () => import(/* webpackChunkName: "opt-in-form" */ '../views/optInForm/ScreenerResponsesList.vue'),
        meta: {
          isCollaborative: true,
          zeroTopNavMargin: true,
        },
      },
    ],
  },
  {
    path: '/project/:projectId/docs',
    name: 'Project Docs',
    component: () => import(/* webpackChunkName: "docs" */ '../views/projects/docs/DocsPage.vue'),
    meta: {
      isCollaborative: true,
    },
  },
  {
    path: '/project/:projectId/participants',
    name: 'Project Participants',
    component: () => import(/* webpackChunkName: "participants" */ '../views/participants/ProjectParticipants.vue'),
    meta: {
      isCollaborative: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/project/:projectId/participants/:participantId',
    name: 'Project Participant Detail',
    component: () => import(/* webpackChunkName: "participants" */ '../views/participants/ParticipantDetail.vue'),
    meta: {
      isCollaborative: true,
      zeroTopNavMargin: true,
      requiresPanelManagement: true,
    },
  },
  {
    path: '/project/:projectId/script',
    name: 'Project Script',
    component: () => import( /* webpackChunkName: "notetaking" */ '../views/projects/question-scripts/Script.vue'),
    meta:{
      isCollaborative: true,
    }
  },
  {
    path: '/project/:projectId/analysis',
    name: 'Project Analysis',
    component: () => import( /* webpackChunkName: "notetaking" */ '../views/analysis/index.vue'),
    meta:{
      isCollaborative: true,
    }
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/project/:projectId/assistants',
    name: 'Project Assistants',
    component: () => import( /* webpackChunkName: "assistant" */ '../views/assistants/projectAssistants.vue'),
    meta: {
      isCollaborative: true,
      requiresAuth: true
    }
  },
  {
    path: '/project/:projectId/tags',
    name: 'Project Tags',
    component: () => import( /* webpackChunkName: "notetaking" */ '../views/projects/ProjectTags.vue')
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import( /* webpackChunkName: "notetaking" */ '../views/About.vue')
  // },
  // {
  //   path:'/test',
  //   name: 'Test',
  //   component: () => import( /* webpackChunkName: "test" */ '../views/Test.vue')
  // }
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// userWorkspace loads asynchronously after Firebase auth resolves, so on a
// hard reload/direct URL nav it can still be null when beforeEach first
// runs. Wait for it (bounded by a timeout) instead of reading it straight
// off the store, so we don't misjudge the flag before it's loaded.
function waitForWorkspace() {
  if (store.state.userWorkspace) return Promise.resolve(store.state.userWorkspace)

  return new Promise((resolve) => {
    let settled = false
    const finish = (val) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      unwatch()
      resolve(val)
    }
    const unwatch = store.watch(
      (state) => state.userWorkspace,
      (val) => {
        if (val) finish(val)
      },
    )
    const timer = setTimeout(() => finish(store.state.userWorkspace), 8000)
  })
}

// navigation guard to check for logged in users
router.beforeEach(async (to, from, next) => {
  console.log('ROUTER INDEX',{to},{from})
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  // Checks if the current route allows collaborative actions
  if (requiresAuth && !auth.currentUser) {
    if(to.name=='repository'){
      localStorage.setItem('redirect_url',to.fullPath)
    }
    next('/login')
    return
  }

  const requiresPanelManagement = to.matched.some(x => x.meta.requiresPanelManagement)
  if (requiresPanelManagement) {
    const workspace = await waitForWorkspace()
    if (!workspace || !workspace.panelManagementEnable) {
      next('/projects')
      return
    }
  }

  next()
})

export default router